<template>
	<div class="home">
		<section class="relative">
			<background />
			<row :align="'center'" :justify="'around'" class="container">
				<column class="align-left" style="margin: 20px;" :width="1/3">
					<h1> Real Business Solutions Using The Best Technology For Your Needs </h1>
					<span>
						Our value proposition is the consistent delivery of positive results
						to our clients. <br /> <br />
						Our services include hosted and managed services; outsourcing and selective
						sourcing; and/or on-site and ad-hoc support
					</span>
				</column>
				<column :width="1/3" class="light-block">
					<h1> Services on Demand </h1>
					<span>
						Success in today's competitive global environment demands timely,
						value based decision making, with equally swift and accurate results. <br /> <br />
						MIT Services offers services perfect for your needs. No matter what you
						require, we can assist you in achieving your goals consistently and economically.
					</span>
					<button @click="contactLink()" class="big" href="/contact.html">1300 360 961</button>
				</column>
				<spacer />
			</row>
		</section>
		<values />
	<spacer />
	</div>
</template>

<script>
import values from './Values';
export default {
name: 'Home',
components: {
	values
},
methods: {
		contactLink() {
			this.$router.push('contact')
		}
	}
}
</script>

<style scoped>
	.background {
		background: #0683c9 url("../../assets/background/results.jpg") no-repeat fixed center;
	}
	section {
		color: rgb(25,25,25);
	}
	@media (orientation: portrait), (max-width: 1280px) {
		button {
			margin: 2em auto;
		}
	}
	
</style>
